import { render, staticRenderFns } from "./brand_story.vue?vue&type=template&id=0fc1b83d&scoped=true&"
import script from "./brand_story.vue?vue&type=script&lang=js&"
export * from "./brand_story.vue?vue&type=script&lang=js&"
import style0 from "./brand_story.vue?vue&type=style&index=0&id=0fc1b83d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc1b83d",
  null
  
)

export default component.exports